/** Legacy path. The primitive lives in `@/components/ui/progress` (DESIGN.md §6). */
export { Progress } from '@/components/ui/progress';

export type { ProgressProps } from '@/components/ui/progress';
